var map = {
	"./ethers/reducer.js": 2489,
	"./ipfs/reducer.js": 2490,
	"./uport/reducer.js": 2491
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2488;


//////////////////
// WEBPACK FOOTER
// ./src/assimilation/store \.\/.+\/reducer\.js$
// module id = 2488
// module chunks = 1